import { z } from 'zod';

// events written before the multi-select change (2026-08-24) store a single value or null
const toList = (value: unknown) => {
    if (value == null) return [];
    return Array.isArray(value) ? value : [value];
};

export const schemaUniqueEnumList = <T extends z.EnumLike>(values: T, message: string) =>
    z.preprocess(
        toList,
        z.array(z.nativeEnum(values)).refine((entries) => new Set(entries).size === entries.length, { message }),
    );
